export const TAX_TYPES = {
    NON_TAXABLE: 'non-taxable',  // 不課税
    TAXABLE: 'taxable',          // 課税
    EXEMPT: 'exempt',            // 免税
    TAX_FREE: 'tax-free'         // 非課税
};

export const TAX_TYPE_LABELS = {
    [TAX_TYPES.NON_TAXABLE]: '対象外',
    [TAX_TYPES.TAXABLE]: '課税',
    [TAX_TYPES.EXEMPT]: '免税',
    [TAX_TYPES.TAX_FREE]: '非課税'
};

// 内税方式: 税込金額から消費税額を算出
export const calculateTaxAmount = (totalAmount, taxRate) => {
    if (!taxRate || taxRate === 0) return 0;
    return Math.floor(totalAmount * taxRate / (100 + taxRate));
};

// インボイス経過措置の控除率（日付ベース判定）
export const getInvoiceDeductionRate = (date, isQualified) => {
    if (isQualified) return 100;
    const d = new Date(date);
    if (d <= new Date('2026-09-30')) return 80;
    if (d <= new Date('2029-09-30')) return 50;
    return 0;
};

// 税区分文字列からオブジェクトに変換（CSV読込用）
// 弥生会計形式に対応: 課対仕入込10%適格, 課税売上込五10%, etc.
export const parseTaxString = (taxStr) => {
    if (!taxStr || taxStr === '対象外' || taxStr === '') {
        return { taxType: TAX_TYPES.NON_TAXABLE, taxRate: 0, isQualified: null };
    }

    // 弥生形式: 課対仕入込10%適格, 課対仕入込8%適格, 課税売上込五10%, 課税売上込五8%
    // 「適格」が含まれていればインボイス適格
    const isQualified = taxStr.includes('適格');

    // 10%パターン
    if (taxStr.includes('10%') || taxStr.includes('10')) {
        if (taxStr.includes('課対仕入') || taxStr.includes('課税売上') ||
            taxStr === '課税10' || taxStr === '課税 10%') {
            return { taxType: TAX_TYPES.TAXABLE, taxRate: 10, isQualified };
        }
    }

    // 8%パターン（軽減税率含む）
    if (taxStr.includes('8%') || taxStr.includes('8') || taxStr.includes('軽減')) {
        if (taxStr.includes('課対仕入') || taxStr.includes('課税売上') ||
            taxStr === '課税8' || taxStr === '課税 8%' || taxStr === '軽減8') {
            return { taxType: TAX_TYPES.TAXABLE, taxRate: 8, isQualified };
        }
    }

    // 既存パターン（後方互換性）
    if (taxStr === '課税10' || taxStr === '課税 10%') {
        return { taxType: TAX_TYPES.TAXABLE, taxRate: 10, isQualified: true };
    }
    if (taxStr === '課税8' || taxStr === '課税 8%' || taxStr === '軽減8') {
        return { taxType: TAX_TYPES.TAXABLE, taxRate: 8, isQualified: true };
    }
    if (taxStr === '非課税') {
        return { taxType: TAX_TYPES.TAX_FREE, taxRate: 0, isQualified: null };
    }
    if (taxStr === '免税') {
        return { taxType: TAX_TYPES.EXEMPT, taxRate: 0, isQualified: null };
    }
    return { taxType: TAX_TYPES.NON_TAXABLE, taxRate: 0, isQualified: null };
};

// 税区分をCSV出力用文字列に変換
export const formatTaxString = (taxType, taxRate) => {
    if (taxType === TAX_TYPES.TAXABLE) {
        return taxRate === 8 ? '課税8' : '課税10';
    }
    if (taxType === TAX_TYPES.TAX_FREE) return '非課税';
    if (taxType === TAX_TYPES.EXEMPT) return '免税';
    return '対象外';
};
